import { useFeatureFlags } from 'utils/features';

export default function useTimeLogFeedEnabled() {
  const toggle = useFeatureFlags('TIME_LOG_FEED');
  const ldToggle = useFeatureFlags('TIME_ENTRY_HISTORY_LOG_FEED');
  return toggle && ldToggle;
}

export function useTimeLogFeedExportEnabled() {
  return useFeatureFlags('TIME_LOG_FEED_EXPORT');
}
